import type { FaireProductEntity } from "../../entity_types/product";

export const p_3kjb442ycs: FaireProductEntity = {
  token: "p_3kjb442ycs",
  type: "product",
  name: '36" Nassa Shell  Lei Necklace',
  brandName: "DK Hawaii",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/aa18a2fdc46100602acb2a1d7a9a671018415944876a5707797dd3871a30dd9d.png",
  priceDollars: 0.67,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8a790caa99e13c6b3a0d99d8401b43d0eb4a9b537d36a83ad20f9fddbd51215f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
